// Mirrors the backend's DefenderXdrRiskGenerationService.FormatAffectedLine (write) /
// ExtractAffectedResourceExamples + FriendlyResourceType (read) pair: integration-sourced risks
// (Defender XDR) and GRC control risks carry their affected object names as an
// "Affected <label>: ["name","name"] (+N more)" line inside the description — there is no
// dedicated structured column. The name list is a JSON array so a name containing a comma
// (Sentinel incident titles, for one) stays a single object; risks written before that change
// carry the legacy "name, name" form, which is still accepted. Last match wins (AI-enriched
// descriptions can contain an unused fallback line above the real one).

// Keep in step with FriendlyResourceType in backend/Services/Defender/DefenderXdrRiskGenerationService.cs
// — same keys, same display nouns. GRC control risks use their evidence type as the label directly
// (e.g. "User Accounts", "Azure Resources"), which falls through unchanged.
export const AFFECTED_RESOURCE_LABELS = {
    'devices/entities': 'Devices & Entities',
    'device': 'Devices',
    'users': 'User Accounts',
    'assets': 'Assets',
    'component': 'Components',
    'entities': 'Entities',
};

const legacySplit = (list) => list.split(',').map(s => s.trim()).filter(s => s.length > 0);

const parseNameList = (list) => {
    if (list.startsWith('[')) {
        try {
            const parsed = JSON.parse(list);
            if (Array.isArray(parsed)) {
                return parsed
                    .filter(s => typeof s === 'string')
                    .map(s => s.trim())
                    .filter(s => s.length > 0);
            }
        } catch {
            // not our array — fall through to the legacy split
        }
    }
    return legacySplit(list);
};

export const parseAffectedResources = (description) => {
    if (!description) return null;
    const matches = [...description.matchAll(/^Affected ([^:]+):\s*(.+)$/gm)];
    if (matches.length === 0) return null;
    const match = matches[matches.length - 1];
    const label = match[1].trim();
    let list = match[2].trim();
    const moreMatch = list.match(/\(\+(\d+) more\)\s*$/);
    const extra = moreMatch ? parseInt(moreMatch[1], 10) : 0;
    if (moreMatch) list = list.slice(0, moreMatch.index).trim();
    const names = parseNameList(list);
    if (names.length === 0) return null;
    return {
        names,
        total: names.length + extra,
        typeLabel: AFFECTED_RESOURCE_LABELS[label] || label,
    };
};
